module.exports = __webpack_public_path__ + "media/newstyle/images/icon-header-aila-editor-75a830984af50ddc7f94f8d605343101.svg";